export enum TipoError {
  errorHttp = 'Error en la petición',
  errorAplicacion = 'Error en la aplicación',
}
